import { TooltipProvider } from "@/components/ui/tooltip";
import { AppRouter } from "@/app/router";

export default function NewUIRoot() {
  return (
    <TooltipProvider>
      <AppRouter />
    </TooltipProvider>
  );
}


